import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_ORIGIN = "https://spotbounty.com";

/**
 * Per-route SEO block. Emits <title>, description, canonical, Open Graph and
 * Twitter Card tags. Optional `noindex` flag flips robots to noindex,follow.
 * Optional `jsonLd` accepts a JSON-serialisable object for structured data.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image = `${DEFAULT_ORIGIN}/og-cover.png`,
  imageWidth,
  imageHeight,
  imageType,
  imageAlt,
  noindex = false,
  jsonLd = null,
}) {
  const url = `${DEFAULT_ORIGIN}${path}`;
  const fullTitle = title ? `${title} · SpotBounty` : "SpotBounty";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex,follow" : "index,follow"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SpotBounty" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      {imageWidth && <meta property="og:image:secure_url" content={image} />}
      {imageWidth && <meta property="og:image:width" content={String(imageWidth)} />}
      {imageHeight && <meta property="og:image:height" content={String(imageHeight)} />}
      {imageType && <meta property="og:image:type" content={imageType} />}
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta name="twitter:card" content="summary_large_image" />
      {imageAlt && <meta name="twitter:url" content={url} />}
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
